import { TooltipProvider } from "@repo/ui/components/tooltip";
import { useCallback, useEffect } from "react";
import { Toolbar, ToolbarButton } from "./components/toolbar";
import { useFullscreen } from "./hooks/use-fullscreen";
import { useRpcChannels } from "./main";
import { IconArrowRotateCounterClockwise } from "central-icons/IconArrowRotateCounterClockwise";
import { IconExpand } from "central-icons/IconExpand";
import { IconTrashCan } from "central-icons/IconTrashCan";

export function ShellApp() {
  const channels = useRpcChannels();
  const { toggleFullscreen } = useFullscreen(channels);

  useEffect(() => {
    channels.core.methods?.requestHtmlRedelivery();
  }, [channels]);

  const handleResetSketch = useCallback(() => {
    channels.core.methods?.requestHtmlRedelivery();
  }, [channels]);

  const handleDeleteSketch = useCallback(() => {
    channels.core.methods?.requestDelete();
  }, [channels]);

  return (
    <TooltipProvider>
      <Toolbar>
        <ToolbarButton
          icon={IconArrowRotateCounterClockwise}
          label="Reset"
          onClick={handleResetSketch}
        />
        <ToolbarButton
          icon={IconExpand}
          label="Fullscreen mode"
          onClick={toggleFullscreen}
        />
        <ToolbarButton
          icon={IconTrashCan}
          label="Delete"
          onClick={handleDeleteSketch}
          variant="destructive"
        />
      </Toolbar>
    </TooltipProvider>
  );
}
